import { render, staticRenderFns } from "./NotificationChannelTemplate.vue?vue&type=template&id=ccf68f78&scoped=true&"
import script from "./NotificationChannelTemplate.vue?vue&type=script&lang=js&"
export * from "./NotificationChannelTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NotificationChannelTemplate.vue?vue&type=style&index=0&id=ccf68f78&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf68f78",
  null
  
)

export default component.exports